import { render, staticRenderFns } from "./index.vue?vue&type=template&id=790cc5c8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790cc5c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('790cc5c8')) {
      api.createRecord('790cc5c8', component.options)
    } else {
      api.reload('790cc5c8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=790cc5c8&scoped=true", function () {
      api.rerender('790cc5c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pay/goods/index.vue"
export default component.exports